/* eslint-disable no-trailing-spaces */
import React from 'react'
import PropTypes from 'prop-types'
import {
  Link,
  Route,
  Routes
} from 'react-router-dom'

//import withStyles from '@material-ui/core/styles/withStyles'

import moduleStyle from 'assets/jss/moduleStyle.jsx'

import Index from './index'
import Market from './market'

class BusinessComponent extends React.Component {
  render () {

    if (window.business && window.business.type == "Market") {
      return <Market  />
    } else if (window.business && window.business.type == "Services") {

    }
    return (
                     
      <Routes>
      <Route path="/" element={<Index />} />

    </Routes>

    )
  }
}

BusinessComponent.propTypes = {
  //classes: PropTypes.object.isRequired,
  //theme: PropTypes.object.isRequired
}

export default BusinessComponent
//export default withStyles(moduleStyle, { withTheme: true })(BusinessComponent)
